import {
  ControlPopupContainer,
  ControlPopupContent,
  SwitchablePopupContainer,
} from './styles';
import { PopupMenu, PopupMenuItem } from './styles';
import { Label, Slider, Switch, useId } from '@fluentui/react-components';
import { useStore } from '../../../../store';
import { TrashSimple, X } from '@phosphor-icons/react';
import { useContext } from 'react';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useTranslation } from 'react-i18next';

interface BreakPopupProps {
  blockId: string;
}

export const BreakPopup = ({ blockId }: BreakPopupProps) => {
  const { updateBlockControl, blocks } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  const { t } = useTranslation('myapps');

  const index = blocks.findIndex((b) => b.id === blockId);

  const sliderId = useId('break-slider');

  const handleChange = (value: string | number | null) => {
    if (value === null) {
      updateBlockControl(blockId, 'break', null);
    } else if (
      blocks[index] &&
      blocks[index].controls.break?.value !== value.toString()
    ) {
      updateBlockControl(blockId, 'break', {
        type: typeof value === 'number' ? 'time' : 'strength',
        value: value.toString(),
      });
    }
  };

  const options = [
    { value: 'default', label: t('TTS_EFFECT_OPTION_DEFAULT') },
    { value: 'x-weak', label: t('TTS_EFFECT_OPTION_X_WEAK') },
    { value: 'weak', label: t('TTS_EFFECT_OPTION_WEAK') },
    { value: 'medium', label: t('TTS_EFFECT_OPTION_MEDIUM') },
    { value: 'strong', label: t('TTS_EFFECT_OPTION_STRONG') },
    { value: 'x-strong', label: t('TTS_EFFECT_OPTION_X_STRONG') },
  ];

  return (
    <ControlPopupContainer>
      <ControlPopupContent>
        <SwitchablePopupContainer>
          <Switch
            style={{ alignItems: 'center' }}
            checked={blocks[index]?.controls.break?.type === 'time'}
            onChange={() =>
              blocks[index]?.controls.break?.type !== 'time'
                ? handleChange(0)
                : handleChange('medium')
            }
            label={
              blocks[index]?.controls.break?.type === 'time'
                ? 'Use time configuration'
                : 'Use constant configuration'
            }
            labelPosition="above"
          />

          {blocks[index]?.controls.break?.type === 'time' ? (
            <>
              <Label htmlFor={sliderId}>
                {blocks[index]?.controls.break?.value}
                &nbsp;milliseconds
              </Label>
              <Slider
                style={{ width: '100%' }}
                value={Number(blocks[index]?.controls.break?.value) || 0}
                min={0}
                max={5000}
                onChange={(_, data) => handleChange(data.value)}
                id={sliderId}
              />
            </>
          ) : (
            <PopupMenu>
              {options.map((option) => (
                <PopupMenuItem
                  isSelected={
                    blocks[index]?.controls.break?.value === option.value
                  }
                  key={crypto.randomUUID() + `break-options-` + option.value}
                  onClick={() => {
                    handleChange(option.value);
                    hideToolbox();
                  }}
                >
                  {option.label}
                </PopupMenuItem>
              ))}
            </PopupMenu>
          )}
        </SwitchablePopupContainer>
      </ControlPopupContent>
      {blocks[index]?.controls.break?.value && (
        <PopupMenuItem
          isSelected={false}
          onClick={() => handleChange(null)}
          style={{ border: '1px solid #fd6262' }}
        >
          <X />
          Clear
        </PopupMenuItem>
      )}
    </ControlPopupContainer>
  );
};
